import React from 'react'
import { motion } from 'framer-motion'

function ReviewCard({ img, con, name }) {
  return (
    <motion.article
      className="relative flex flex-col h-full bg-white rounded-2xl sm:rounded-3xl shadow-lg border border-review-border overflow-hidden"
      whileHover={{ y: -4, boxShadow: '0 20px 40px -15px rgba(0, 137, 154, 0.2)' }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className="pt-24 sm:pt-28 px-5 sm:px-6 pb-5 sm:pb-6">
        <p className="text-[14px] sm:text-[15px] text-[#344054] leading-relaxed mb-5">
          {con}
        </p>
        <p className="text-primary-color font-[500] text-[15px] sm:text-[16px] mt-auto">
          — {name}
        </p>
      </div>
      <div className="absolute top-0 left-0 right-0 flex justify-center pt-6">
        <img
          src={img}
          alt={name}
          className="w-14 h-14 sm:w-16 sm:h-16 object-cover rounded-full ring-4 ring-white shadow-md"
        />
      </div>
    </motion.article>
  )
}

export default ReviewCard
